const schema = {
    dataTransferencia: {
        id: 'dataTransferencia',
        label: 'Data de transferência',
        help: 'Data sugerida pelo sistema. Alterar a data de transferência gera cobrança do valor integral do plano na próxima fatura.',
        mask: '',
        required: true,
        type: 'date',
        requiredMessage: 'Preencha a data de transferência',
    },
    novoContrato: {
        id: 'novoContrato',
        label: 'Novo contrato',
        help: '',
        mask: '',
        required: true,
        type: 'select',
        requiredMessage: 'Selecione um contrato ativo',
        options: [],
    },
    novaLotacao: {
        id: 'novaLotacao',
        label: 'Nova lotação',
        help: '',
        mask: '',
        required: false,
        type: 'select',
        requiredMessage: '',
        options: [],
    },
    state: {
        id: 'state',
        label: 'Estado de atendimento',
        placeholder: 'Selecione',
        type: 'select',
    },
    city: {
        id: 'city',
        label: 'Município de atendimento',
        type: 'select',
        options: [],
    },
    novoCentroCusto: {
        id: 'novoCentroCusto',
        label: 'Novo centro de custo',
        help: '',
        mask: '',
        required: false,
        type: 'select',
        requiredMessage: '',
        options: [],
    },
    novoPlano: {
        id: 'novoPlano',
        label: 'Novo plano',
        help: '',
        mask: '',
        required: true,
        type: 'select',
        requiredMessage: '',
        options: [],
    },
    novoPlanoDependente: {
        id: 'novoPlanoDependente',
        label: 'Novo plano dependente',
        help: '',
        mask: '',
        required: false,
        type: 'select',
        requiredMessage: '',
        options: [],
    },
    novoPlanoAgregado: {
        id: 'novoPlanoAgregado',
        label: 'Novo plano agregado',
        help: '',
        mask: '',
        required: false,
        type: 'select',
        requiredMessage: '',
        options: [],
    },
    novaMatricula: {
        id: 'novaMatricula',
        label: 'Nova matrícula',
        help: '',
        mask: '9'.repeat(30),
        required: false,
        type: 'text',
        requiredMessage: 'Informe a nova matrícula',
    },
};

export default schema;
